import { colors } from "../colors";
import { AvatarTheme } from "./types";

export const avatar: AvatarTheme = {
    sizes: {
        S: {
            avatarSize: "3rem",
            fontSize: "1.2rem",
        },
        M: {
            avatarSize: "3.5rem",
            fontSize: "1.4rem",
        },
        L: {
            avatarSize: "4rem",
            fontSize: "1.6rem",
        },
    },
    defaults: {
        size: "M",
        textColor: colors.purple.primary,
        bgColor: colors.purple.secondary,
        fontWeight: "Regular",
        fontFamily: "Open Sans",
        borderColor: colors.grey.primary,
        borderRadius: "50%",
        hover: {
            textShadowColor: "rgba(0, 90, 238, 0.35)",
            imgShadowColor: "rgba(96, 120, 144, 0.35)",
            textColor: colors.white,
            bgColor: colors.purple.primary,
        },
        pressed: {
            bgColor: colors.purple.secondary,
            textColor: colors.white,
        },
    },
};
